// StatusTag — farebný štítok stavu dokladu (ústava 21.15 — z TINT, nie inline).
// ZDIEĽANÝ komponent (Mirko 2026-07-27: „prečo neurobíš rovnaký dizajn — to je príkaz ústava").
// Používa ho stavebná CP (CenoveView) aj predajňová CP (PredajnaCP) — JEDNA definícia,
// aby sa vzhľad oboch nemohol časom rozísť.
import React from 'react'
import { COLORS, TYPO, RADIUS } from '../theme.js'

export const STATUS_LABEL = {
  draft: 'Pracovná',
  sent: 'Odoslaná',
  accepted: 'Akceptovaná',
  rejected: 'Zamietnutá',
  active: 'Aktívna',
  // Objednávka v Predajni (ústava 124) — ADITÍVNE
  koncept: 'Koncept',
  odoslana: 'Odoslaná',
  potvrdena: 'Potvrdená',
  dodana: 'Dodaná',
  zrusena: 'Zrušená',
}

export default function StatusTag({ status }) {
  // Mirko 2026-07-16: Odoslaná = ZELENÁ, Pracovná = ČERVENÁ (accepted zelená, rejected sivá).
  // TINT.remove má alpha 0.04 — pre badge nepoužiteľný, preto plné odtiene.
  const M = {
    sent:     { c: '#15803d', bg: '#dcfce7' },
    accepted: { c: '#15803d', bg: '#dcfce7' },
    active:   { c: '#15803d', bg: '#dcfce7' },
    draft:    { c: '#dc2626', bg: '#fee2e2' },
    koncept:  { c: '#dc2626', bg: '#fee2e2' },
    odoslana: { c: '#185fa5', bg: '#dbeafe' },
    potvrdena:{ c: '#15803d', bg: '#dcfce7' },
    dodana:   { c: '#15803d', bg: '#dcfce7' },
  }
  const m = M[status] || { c: COLORS.muted, bg: COLORS.lineSoft }
  return (
    <span style={{
      fontSize: TYPO.sizes.xs,
      fontWeight: TYPO.weights.semibold,
      color: m.c,
      background: m.bg,
      borderRadius: RADIUS.sm,
      padding: '1px 7px',
    }}>{STATUS_LABEL[status] || status || '—'}</span>
  )
}
